export default __webpack_public_path__ + "media/images/theme/bg_light-088231136afe5235c4168fd1500bd957.png";